/**
 * About page tabs (sections/about.liquid). Selection follows the URL
 * hash so the header's About sub-links (/pages/about#philosophy, …)
 * land with the right panel open, and switching tabs rewrites the
 * hash without adding history entries. Re-binds after theme editor
 * re-renders (shopify:section:load replaces the DOM).
 */
function tabs() {
  return [...document.querySelectorAll('[data-about-tab]')];
}

function select(id, updateHash) {
  const all = tabs();
  if (!all.length) return;
  const target = all.some((t) => t.dataset.aboutTab === id) ? id : all[0].dataset.aboutTab;
  for (const tab of all) {
    const active = tab.dataset.aboutTab === target;
    tab.setAttribute('aria-selected', String(active));
  }
  for (const panel of document.querySelectorAll('[data-about-panel]')) {
    panel.hidden = panel.dataset.aboutPanel !== target;
  }
  if (updateHash) history.replaceState(null, '', `#${target}`);
}

function fromHash() {
  select(location.hash.slice(1), false);
}

function bind() {
  const row = document.querySelector('.about__tabs');
  if (!row || row.dataset.bound) return;
  row.dataset.bound = 'true';
  row.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-about-tab]');
    if (tab) select(tab.dataset.aboutTab, true);
  });
  fromHash();
}

window.addEventListener('hashchange', fromHash);
document.addEventListener('shopify:section:load', bind);
bind();
